<template>
  <v-card
    :href="link"
    @click.prevent="handleLink"
    :style="cardStyle"
    class="proposal-custom-image"
    v-intersect.once="handleView"
  >
    <v-img
      :src="imgSrc"
      :alt="proposal.imgAlt"
      :title="proposal.imgDescription"
      :eager="eager"
    >
      <div
        class="blurred-bg"
        v-if="
          $ebsn.meta(
            proposal,
            'metaData.category_proposal_type.SHOW_BLACK_LAYER'
          )
        "
      ></div>
      <div
        class="text-overlay"
        :class="
          $ebsn.meta(
            proposal,
            'metaData.category_proposal_type.TEXT_ALIGN',
            ' text-align-center '
          ) +
            ' ' +
            $ebsn.meta(
              proposal,
              'metaData.category_proposal_type.TEXT_ALIGN_HORIZONTAL',
              ' text-align-center '
            ) +
            ' ' +
            $ebsn.meta(
              proposal,
              'metaData.category_proposal_type.TEXT_ALIGN_VERTICAL',
              ' '
            )
        "
      >
        <div
          class="recipe-content d-flex px-4"
          v-if="proposal.recipe_cook_time || proposal.rating"
        >
          <div class="chip-info" v-if="proposal.recipe_cook_time">
            <v-icon color="black">$schedule</v-icon>
            <span class="px-1">
              {{ proposal.recipe_cook_time }}
              {{ proposal.recipe_cook_time_text }}
            </span>
          </div>
          <div class="chip-info" v-if="proposal.rating">
            <v-icon color="black" class="mb-1">$signal</v-icon>
            <span class="pr-1">{{ proposal.rating }}</span>
          </div>
        </div>
        <v-card-title
          class="pt-1"
          v-if="proposal.descr"
          v-html="proposal.descr"
        ></v-card-title>
        <v-card-text
          v-if="proposal.content"
          v-html="proposal.content"
          class="pb-1"
        ></v-card-text>
      </div>
      <div class="actions-overlay">
        <v-card-actions
          class="pt-0"
          v-if="
            $ebsn.meta(proposal, 'metaData.category_proposal_type.BTN_TEXT')
          "
        >
          <v-btn
            :href="link"
            :outlined="
              $ebsn.meta(
                proposal,
                'metaData.category_proposal_type.BTN_OUTLINED',
                false
              )
            "
            :color="
              $ebsn.meta(
                proposal,
                'metaData.category_proposal_type.BTN_COLOR',
                'primary'
              )
            "
            >{{
              $ebsn.meta(proposal, "metaData.category_proposal_type.BTN_TEXT")
            }}</v-btn
          >
        </v-card-actions>
      </div>
    </v-img>
  </v-card>
</template>
<style lang="scss">
.proposal-custom-image.v-card {
  overflow: hidden;
  height: 100%;
  .blurred-bg:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent 30%, black 100%);
  }
  .v-image {
    height: 100%;
    color: inherit;
  }
  .text-overlay {
    &.text-align-center {
      .v-card__title,
      .v-card__text {
        text-align: center;
      }
    }
    &.text-align-left {
      .v-card__title,
      .v-card__text {
        text-align: left;
      }
    }
    &.text-align-right {
      .v-card__title,
      .v-card__text {
        text-align: right;
      }
    }
    .chip-info {
      background-color: $white;
      color: var(--v-default-base);
      padding: 4px;
      margin-right: 6px;
      border-radius: 25px;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .actions-overlay {
    bottom: 0px;
    position: absolute;
    width: 100%;
    justify-content: center;
    display: flex;
    &.text-align-center {
      .v-card__actions {
        text-align: center;
        justify-content: center;
      }
    }
    &.text-align-left {
      .v-card__actions {
        text-align: left;
        justify-content: flex-start;
      }
    }
    &.text-align-right {
      .v-card__actions {
        text-align: right;
        justify-content: flex-end;
      }
    }
  }
}
</style>
<script>
import banner from "~/mixins/banner";

import get from "lodash/get";

export default {
  name: "ProposalImage",
  props: {
    proposal: { type: Object, required: true },
    eager: { type: Boolean, default: false }
  },
  mixins: [banner],
  computed: {
    cardStyle() {
      let style = {};
      let backgroundColor = get(
        this.proposal,
        `metaData.category_proposal_type.BACKGROUND_COLOR`
      );
      if (backgroundColor) {
        style.backgroundColor = backgroundColor;
      }
      let textColor = get(
        this.proposal,
        `metaData.category_proposal_type.TEXT_COLOR`
      );
      if (textColor) {
        style.color = textColor;
      } else {
        style.color = "var(--v-white-base)";
      }

      return style;
    },
    imgSrc() {
      let prop =
        "metaData.category_proposal_type." +
        (!this.$vuetify.breakpoint.xsOnly ? "IMAGE_DESKTOP" : "IMAGE_MOBILE");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
